import { LoadingButton } from "@mui/lab";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Stack,
  Typography
} from "@mui/material";
import useAuth from "app/hooks/useAuth";
import { LinkStyle } from "app/utils/global_constants";
import { useState } from "react";
import { Link } from "react-router-dom";
import LocationSelect from "./LocationSelect";

function ApplyDialogContent({
  handleCloseDialog,
  isApplying,
  application,
  apply,
  locations,
  isRemoteWork
}) {
  const [preferredLocation, setPreferredLocation] = useState([]);
  const isSubmitDisabled = !isRemoteWork && preferredLocation.length === 0;
  const { user } = useAuth();

  return (
    <>
      <DialogContent>
        <DialogContentText sx={{ color: "black" }}>
          Review your profile before submitting:{" "}
          <Link to={`/candidate/detail/${user.id}`} target={"_blank"} style={LinkStyle}>
            View Profile
          </Link>
        </DialogContentText>
        <DialogContentText sx={{ color: "black" }}>
          Edit your profile if you need:{" "}
          <Link to={"/profile/2"} target="_blank" state={{ tab: "2" }} style={LinkStyle}>
            Edit Profile
          </Link>
        </DialogContentText>
        {!isRemoteWork && (
          <Stack mt={2} gap={1}>
            <Typography fontWeight={"bold"}>Your location preference is required*: </Typography>
            <LocationSelect
              value={preferredLocation}
              locations={locations}
              onChange={(value) => {
                setPreferredLocation(value);
              }}
            />
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog}>Cancel</Button>
        <LoadingButton
          variant="contained"
          loading={isApplying}
          disabled={isSubmitDisabled}
          onClick={() => {
            if (application) {
              apply({ ...application, jp_location_preference: preferredLocation.join("|") });
            }
          }}
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </>
  );
}

export default ApplyDialogContent;
